import { baseApi } from "../redux/baseAPI";

export const vezoSessionsApi = baseApi.injectEndpoints({
  tagTypes: [
    "vezoSessionsListing",
    "vezoSessionsWaitingList",
    "patientSessionContact",
    "viewVezoSession"
  ],
  endpoints: (builder) => ({
    getVezoRooms: builder.query({
      query: (params) => {
        return {
          url: `/telemeds/get_user_rooms.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["vezoRooms"],
    }),
    getVezoSessionsListing: builder.query({
      query: (params) => {
        return {
          url: `/telemeds/index.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["vezoSessionsListing"],
    }),
    getVezoSessionsWaitingList: builder.query({
      query: (params) => {
        return {
          url: `/telemeds/waiting_list.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["vezoSessionsWaitingList"],
    }),
    getVezoSessionsItem: builder.query({
      query: (params) => {
        return {
          url: `/telemeds/view.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data
    }),
    getVezoDisclaimer: builder.query({
      query: (params) => {
        return {
          url: `/users/all_tnc.json?type=telemed_provider`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data
    }),
    saveSession: builder.mutation({
      query: (body) => ({
        url: `/telemeds/save.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      invalidatesTags: ["vezoSessionsListing", "vezoSessionsWaitingList"],
    }),
    checkRoom: builder.mutation({
      query: (body) => ({
        url: `/telemeds/check_room_availability.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    createRoom: builder.mutation({
      query: (body) => ({
        url: `/telemeds/create_room.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getNursingHomeCalls: builder.query({
      query: (params) => {
        return {
          url: `/nursing_home_calls/index.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data
    }),
    getPatientContact: builder.query({
      query: (params) => {
        return {
          url: `/patients/contacts.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["patientSessionContact"],
    }),
    getVezoRoomUser: builder.query({
      query: (params) => {
        return {
          url: `/telemeds/get_room_users.json?`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data
    }),
    getVezoSession: builder.query({
      query: (params) => {
        return {
          url: `/telemeds/view.json?`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["viewVezoSession"],
    })
  }),
});

export const {
  useGetVezoRoomsQuery,
  useGetVezoSessionsListingQuery,
  useGetVezoSessionsWaitingListQuery,
  useGetVezoSessionsItemQuery,
  useGetVezoDisclaimerQuery,
  useSaveSessionMutation,
  useCheckRoomMutation,
  useCreateRoomMutation,
  useGetNursingHomeCallsQuery,
  useGetPatientContactQuery,
  useGetVezoRoomUserQuery,
  useGetVezoSessionQuery
} = vezoSessionsApi;
